import React from 'react';

class TextAreaBox extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value
		};
	}

	// Public API
	setValue = (value) => {
		this._update(value);
	}

	getValue = () => {
		return this.state.value;
	}

	focus = () => {
		this._input.focus();
	}

	select = () => {
		this._input.select();
	}

	flag = (status) => {
		if (!status)
			this._input.classList.add('invalid-field');
		else
			this._input.classList.remove('invalid-field');
	}

	validate = () => {
		if (this.props.onValidate)
			this.props.onValidate(this.state.value);
		else
			return null;
	}
	
	completed = () => {
		return !((this.state.value === "" || this.state.value === null) && this.props.required)
	}

	// Private
	_filter = (e) => {
		if (this.props.filter) {
			if (!this.props.filter(e.key))
				e.preventDefault();
		}
	}
	
	_className = () => {
		if (this.props.className !== undefined)
			return this.props.className;
		else
			return "";
	}

	_update = (value) => {
		this.setState({ value }, function () {
			const requiredPassed = this.completed();
			const validationPassed = (this.validate() === null);
			const status = requiredPassed && validationPassed;

			// Show error status if neccesary
			this.flag(status);

			// Trigger standard onChange...
			this.props.onChange && this.props.onChange(value);

			// If managed by forms, trigger field change
			if (this.props.managed)
				this.props.onFieldChange(value, this.props.name);
		});
	}

	_handleInputChange = (e) => {
		this._update(e.target.value);
	}

	_handleInputKeyDown = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	_handleInputKeyPress = (e) => {
		this._filter(e);
	}

	_remaining = () => {
		if (!this.props.maxLength || !this.state.value)
			return null;

		return this.props.maxLength - this.state.value.length;
	}

	// React lifecycle events
	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.state.value) {
			this.setState({
				value: nextProps.value
			});
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextState.value !== this.state.value
			|| nextProps.disabled !== this.props.disabled);
	}

	render() {
		const props = {
			name: this.props.name,
			value: this.state.value || "",
			type: "text",
			maxLength: this.props.maxLength,
			placeholder: this.props.placeholder,
			style: this.props.style,
			autoComplete: "off",
			cols: this.props.cols,
			rows: this.props.rows,
			className: "form-control " + this._className(),
			disabled: this.props.disabled ? "disabled" : undefined,
			onChange: this._handleInputChange,
			onKeyDown: this._handleInputKeyDown,
			onKeyPress: this._handleInputKeyPress
		};

		const remaining = this._remaining();

		return (
			<React.Fragment>
				<textarea {...props} ref={(input) => { this._input = input; }} />
				{remaining !== null && <span><small>{remaining} remaining chars.</small></span>}
			</React.Fragment>);
	}
}

export default TextAreaBox;

TextAreaBox.defaultProps = {
	formControl: true,
	managed: false
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/textAreaBox/textAreaBox.js